/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ShopSearchProductsRequest} from '@cash-web/protos/squareup/cash/customersearch/api/ShopSearchProducts.pb'
import {ShopSearchProductsResponse} from '@cash-web/protos/squareup/cash/customersearch/api/ShopSearchProducts.pb'


export const shopSearchProducts = (request:ShopSearchProductsRequest, options?: CashRequestOptions) => post<ShopSearchProductsRequest, ShopSearchProductsResponse>("/2.0/cash/shop-search-products", request, {...options, rejectOnError: true })